import React, { useCallback } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import { toggleSubFilters, clearSubFilters } from 'tripPlanner/reducers/actions'
import { TripPlannerFilterTypeCount } from 'tripPlanner/utils/summary'
import FilterChipsScrollContainer from 'tripPlanner/components/TripItemFilters/FilterChipsScrollContainer'
import FilterChipsWrapContainer from 'tripPlanner/components/TripItemFilters/FilterChipsWrapContainer'
import FilterChips from './FilterChips'

function TripPlannerFilters({
  availableSubFilters = EmptyArray,
  selectedFilters,
  itemCount,
  style,
}: {
  itemCount: number
  availableSubFilters: Array<TripPlannerFilterTypeCount>
  selectedFilters: Array<App.TripPlannerSubFilterType>
  style: 'scroll' | 'wrap'
}) {
  const dispatch = useAppDispatch()

  const clearFilters = useCallback(() => {
    dispatch(clearSubFilters())
  }, [dispatch])

  const toggleSubFilter = useCallback(
    (filterType: App.TripPlannerSubFilterType) => {
      dispatch(toggleSubFilters(filterType))
    },
    [dispatch],
  )

  if (itemCount === 0 || availableSubFilters.length === 0) return null

  const Container = style === 'scroll' ? FilterChipsScrollContainer : FilterChipsWrapContainer

  return <Container>
    <FilterChips
      itemCount={itemCount}
      availableSubFilters={availableSubFilters}
      selectedFilters={selectedFilters}
      onClearFilters={clearFilters}
      onToggleFilter={toggleSubFilter}
    />
  </Container>
}

export default TripPlannerFilters
